import Mustache from 'mustache';
import localizations from './localizations';

/**
 * Get funding data from an ajax endpoint and render results
 *
 * @class fundingCalculator
 */
class fundingCalculator {
  constructor() {
    this.monthlyPaymentResult = document.querySelector('.js-funding-calculator__monthly-payment');
    this.contractTime = document.querySelector('.js-funding-calculator__contract_time');
    this.financedAmount = document.querySelector('.js-funding-calculator__financed_amount');
    this.fundingCalculatorResult = document.querySelector('.js-funding-calculator__result');
    this.fundingCalculatorFormCalculations= document.querySelector('.js-funding-calculator__form-calculations');
    this.fundingCalculatorFormInputs = document.querySelector('.js-funding-calculator__form-inputs');
    this.fundingCalculatorForm = document.getElementById('funding-calculator');

    this.formTimeOutId = null;

    this.templatefundingCalculatorResult = document.getElementById('mustache-funding-calculator-result')?.innerHTML;
    this.templatefundingCalculatorFormCalculations = document.getElementById('mustache-funding-calculator-form-calculations')?.innerHTML;
    this.templatefundingCalculatorFormInputs = document.getElementById('mustache-funding-calculator-form-inputs')?.innerHTML;
  }

  /**
   * Get funding data from an ajax endpoint
   *
   * @param {*} form finance calculator form element
   * @return {*} request response or rejected promise
   * @memberof fundingCalculator
   */
  _getFundingData(form) {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      const queryString = '?' + new URLSearchParams(new FormData(form)).toString();

      request.open('GET', '/stage-ajax/getFunding' + queryString, true);
      request.send();

      request.onload = () => {
        if(request.readyState === 4 && request.status === 200) {
          resolve(request.response);
        } else reject(request)
      }
    });
  }

  /**
   * Render ajax result as html via mustache
   *
   * @param {*} response json response from ajax endpoint
   * @memberof fundingCalculator
   */
  _renderFundingData(response) {
    response = JSON.parse(response);
    this.monthlyPaymentResult.innerHTML = response.formattedResult.monthlyTranche;
    this.contractTime.innerHTML = response.formattedResult.paymentMonths;
    this.financedAmount.innerHTML = response.formattedResult.financedAmount;
    this.fundingCalculatorResult.innerHTML = Mustache.render(this.templatefundingCalculatorResult, response.formattedResult);
    this.fundingCalculatorFormCalculations.innerHTML = Mustache.render(this.templatefundingCalculatorFormCalculations, response.formattedResult);
    this.fundingCalculatorFormInputs.innerHTML = Mustache.render(this.templatefundingCalculatorFormInputs, response.originalValues);
  }

  /**
   * Render error if something goes wrong.
   *
   * @param {*} error errormessage
   * @memberof fundingCalculator
   */
  _renderError(error) {
    this.monthlyPaymentResult.innerHTML = '-';
    this.fundingCalculatorResult.innerHTML = `<h3 class="error-text">${localizations.general_error}</h3>`;
  }

  /**
   * Initialize eventlisteners
   *
   * @memberof fundingCalculator
   */
  init() {
    if (this.fundingCalculatorForm) {
      this.fundingCalculatorForm.addEventListener('submit', e => {
        e.preventDefault();

        this._getFundingData(e.target)
          .then(fundingData => {
            this._renderFundingData(fundingData);
          })
          .catch(errorMessage => {
            this._renderError(errorMessage)
          })
      });

      //trigger submit after input change (with buffer).
      this.fundingCalculatorForm.addEventListener('change', e => {
        clearTimeout(this.formTimeOutId);
        this.monthlyPaymentResult.innerHTML = '-';

        this.formTimeOutId = setTimeout(() => {
          const event = new Event('submit', { cancelable: true });
          this.fundingCalculatorForm.dispatchEvent(event);
        }, 500);
      })
    }
  }
}

export default new fundingCalculator();
